import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from "@/views";
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import VueLazyload from "vue-lazyload";
import '@/lib/array.extension'
import duration from "dayjs/plugin/duration";
import {session} from "@/model/session";
import tLbsMap from 'tlbs-map-vue';
import emit from "@/lib/emit";
import dayjs from "dayjs";
import NutUI from "@nutui/nutui";
import '@nutui/nutui/dist/style.css'

const app = createApp(App).use(Antd).use(NutUI).use(VueLazyload, {
    preLoad: 1.3,
    loading: require('@/assets/image/loading_template.gif'),
    attempt: 1
}).use(tLbsMap)

dayjs.extend(duration)
session.begin(app).then(() => app.use(router).mount('#app'))

// 探测窗口变化是为了首页的裂变玩法横向自适应滚动
window.addEventListener('resize', (evt) => emit.emit('window.resize', evt))